import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";

const useInitParentsData = (sha1?: string) => {
  const { data: relationshipsData, isFetching } = useQuery({
    queryKey: ["sourcesData", sha1],
    queryFn: () => api.sourcesData(sha1),
    select: ({ data }) => {
      const relationships = data.sources?.relationships;

      return [
        ...(relationships?.container_samples ?? []),
        ...(relationships?.parent_samples ?? [])
      ];
    },
    enabled: Boolean(sha1),
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  return {
    data: {
      relationshipsData
    },
    counts: {
      totalParents: relationshipsData?.length ?? 0
    },
    actions: null,
    isFetching
  };
};

export default useInitParentsData;
